import skapiecLogo from 'assets/images/main-partners/skapiec.inline.svg';
import idoSell from 'assets/images/main-partners/idosell.inline.svg';
import shoperLogo from 'assets/images/main-partners/shoper.inline.svg';
import redcartLogo from 'assets/images/main-partners/redcart.inline.svg';
import cstoreLogo from 'assets/images/main-partners/cstore.png';
import sellyLogo from 'assets/images/main-partners/selly.inline.svg';
import webMarketLogo from 'assets/images/main-partners/webmarket.png';
import goshopLogo from 'assets/images/main-partners/goshop.gif';
import aptusLogo from 'assets/images/main-partners/aptusshop.inline.svg';
import skyShopLogo from 'assets/images/main-partners/skyshop.inline.svg';
import laModaLogo from 'assets/images/main-partners/lamoda.inline.svg';
import wzLogo from 'assets/images/main-partners/wz.inline.svg';
import trisoshopLogo from 'assets/images/main-partners/trisoshop.inline.svg';
import soteLogo from 'assets/images/main-partners/sote.inline.svg';
import woocommerceLogo from 'assets/images/main-partners/woocommerce.inline.svg';
import homeLogo from 'assets/images/main-partners/home.jpg';

export default [
    {
        title: 'Skąpiec.pl',
        url: 'https://www.skapiec.pl/',
        description: 'Skapiec to jedna z pierwszych porównywarek cen na polskim rynku. Nieprzerwanie'
            + ' i&nbsp;z&nbsp;sukcesami działa już od 2004 roku. Serwis umożliwia sprawdzenie i porównanie ofert'
            + ' ponad 3100 e‑sklepów, w tym m.in. Media Markt, Saturn, RTV Euro AGD, Electro, Neo24, Redcoon, Agito,'
            + ' OleOle, Zalando czy Merlin. Od początku działalności cieszy się opinią najbardziej przyjaznej'
            + ' internetowej porównywarki cen. Systematycznie poszerza też obszary swojej działalności – na dzień'
            + ' dzisiejszy katalog Skąpiec.pl obejmuje aż 11 milionów produktów z&nbsp;22&nbsp;branż. Najnowsze'
            + ' z nich to: Motoryzacja, Gry, Budowa i remont domu oraz Wyposażenie mieszkania. Według statystyk'
            + ' Google, serwis co miesiąc odwiedza 3,8&nbsp;mln unikalnych użytkowników, generując przy tym aż'
            + ' 24&nbsp;mln odsłon.',
        image: skapiecLogo,
        doFolow: true
    },
    {
        title: 'LaModa',
        url: 'https://lamoda.pl',
        description: 'LaModa.pl to platforma sprzedażowa dla kobiet kochających modę, ceniących unikalny styl'
            + ' i poszukujących wciąż nowych inspiracji. Miejsce, w którym odnaleźć można zarówno zagraniczne,'
            + ' ekskluzywne marki jak i kolekcje młodych, polskich projektantów.',
        image: laModaLogo,
        doFolow: true
    },
    {
        title: 'IdoSell',
        url: 'https://www.idosell.com/pl/',
        description: 'IdoSell to dostępne w modelu SaaS najlepsze rozwiązanie dla sklepu internetowego lub hurtowni'
            + ' internetowej. Dzięki wieloletniemu doświadczeniu i wsłuchiwaniu się w potrzeby Klientów, IdoSell.com'
            + ' oferuje innowacyjne rozwiązania, które wyznaczają trendy na rynku e–commerce. Klienci IdoSell.com'
            + ' są zawsze o krok przed konkurencją,  ponieważ otrzymują tysiące nowatorskich funkcji zamkniętych'
            + ' w przyjaznym interfejsie. Elastyczna oferta, kompleksowa usługa i sprawna pomoc techniczna to tylko'
            + ' część atutów platformy. Firma oferuje największą ilość dostępnych od ręki, profesjonalnych aplikacji,'
            + ' które stanowią punkt wyjścia do zbudowania sklepu i hurtowni pod indywidualne potrzeby Klientów.'
            + ' Doświadczenie, najwyższe standardy bezpieczeństwa oraz przejrzysta struktura opłat sprawiają, że'
            + ' z roku na rok IdoSell.com pozyskuje setki nowych Klientów. Należą do nich nie tylko uznane marki'
            + ' krajowe, ale również międzynarodowe firmy, które funkcjonują głównie w Wielkiej Brytanii i Niemczech'
            + ' pod marką IdoSell.com.\nAby dowiedzieć się więcej, obejrzeć przykładowe wdrożenia lub skorzystać'
            + ' z bezpłatnego demo, przejdź na stronę IdoSell.com.',
        image: idoSell
    },
    {
        title: 'Shoper.pl',
        url: 'https://www.shoper.pl/',
        description: 'Shoper.pl to gotowy sklep internetowy. Posiada ponad 250 funkcji, które ułatwiają sprzedaż'
            + ' i maksymalnie skracają czas potrzebny na otwarcie własnego biznesu. Jest to program obsługiwany przez'
            + ' przeglądarkę internetową. Nie wymaga instalacji ani żadnej wiedzy specjalistycznej. Każdy uruchomiony'
            + ' sklep posiada uniwersalną stronę www, którą można łatwo modyfikować. Oprogramowanie pozwala na pełne'
            + ' dostosowanie wyglądu sklepu do swoich potrzeb. Może on działać pod dowolną domeną www.\n\n'
            + ' Sklep jest stale rozwijany i wzbogacany o nowe funkcje. Klienci Shoper mogą zawsze liczyć na'
            + ' pomoc Działu Obsługi Klienta.\n\nPierwsza wersja Shoper powstała 8 lat temu. Od tego czasu wybrało'
            + ' go już ponad 8000 firm. Zdobył uznanie w branży e-commerce (dwukrotnie Najlepsza Platforma E-commerce'
            + ' na Targach Ehandlu). Użytkownicy cenią go za intuicyjną obsługę i łatwość modyfikacji. Dzięki'
            + ' wbudowanym integracjom z firmami kurierskimi, płatnościami online, Pocztą Polską, Allegro i'
            + ' porównywarkami cen, sprzedaż przebiega w sposób zautomatyzowany.',
        image: shoperLogo
    },
    {
        title: 'Redcart.pl',
        url: 'https://redcart.pl/',
        description: 'Redcart.pl to zaawansowana platforma sklepów internetowych z pełnym pakietem użytecznych'
            + ' narzędzi do prowadzenia każdego rodzaju ebiznesu. Ponad 50 integracji z porównywarkami cen, pasażami'
            + ' sklepów, płatnościami elektronicznymi, systemami F/K, fakturami, kurierami oraz integracje z'
            + ' dowolnymi hurtowniami to doskonałe narzędzie do szybkiego rozwoju. Nieograniczona możliwość'
            + ' indywidualnej rozbudowy, częste bezpłatne aktualizacje oraz minimalne koszty początkowe dla'
            + ' rozpoczynających sprzedaż przez internet to podstawowe zalety platformy Selly. Oprogramowanie'
            + ' dedykowane jest dla wszystkich firm poszukujących bardzo wydajnego sklepu internetowego z'
            + ' możliwością indywidualnej rozbudowy.',
        image: redcartLogo
    },
    {
        title: 'cSTORE',
        url: 'https://www.cstore.pl/',
        description: 'cSTORE to najbardziej rozbudowane oprogramowanie dla sklepu internetowego. Posiadamy ponad'
            + ' 9 letnie doświadczenie w branży e-commerce, dzięki czemu jakość i funkcjonalność naszych rozwiązań'
            + ' stała się synonimem potrzeb Klienta. Gwarancją naszego sukcesu jest permanentny rozwój, który'
            + ' wyznacza standardy na rynku. Zapraszamy do przetestowania naszego oprogramowania na stronie cStore.pl',
        image: cstoreLogo
    },
    {
        title: 'Selly',
        url: 'https://www.selly.pl/',
        description: 'Selly to zaawansowana platforma sklepów internetowych z pełnym pakietem użytecznych narzędzi'
            + ' do prowadzenia każdego rodzaju ebiznesu. Ponad 50 integracji z porównywarkami cen, pasażami sklepów,'
            + ' płatnościami elektronicznymi, systemami F/K, fakturami, kurierami oraz integracje z dowolnymi'
            + ' hurtowniami to doskonałe narzędzie do szybkiego rozwoju. Nieograniczona możliwość indywidualnej'
            + ' rozbudowy, częste bezpłatne aktualizacje oraz minimalne koszty początkowe dla rozpoczynających'
            + ' sprzedaż przez internet to podstawowe zalety platformy Selly. Oprogramowanie dedykowane jest dla'
            + ' wszystkich firm poszukujących bardzo wydajnego sklepu internetowego z możliwością indywidualnej'
            + ' rozbudowy.',
        image: sellyLogo
    },
    {
        title: 'GOshop.pl',
        url: 'https://www.goshop.pl/',
        description: 'GOshop.pl jest nowoczesnym rozwiązaniem do prowadzenia handlu internetowego. Indywidualne'
            + ' podejście do Klienta oraz szeroki wachlarz funkcjonalności pozwala na rozpoczęcie i rozwijanie'
            + ' swojego internetowego biznesu.',
        image: goshopLogo
    },
    {
        title: 'Web-Market',
        url: 'https://www.web-market.pl',
        description: 'Web-Market to bogate w funkcje oprogramowanie do prowadzenia sklepu internetowego'
            + ' zintegrowane z wieloma pasażami, płatnościami on-line oraz porównywarkami cen. Obsługuje wszystkie'
            + ' wersje językowe i waluty świata. Umożliwia prace z dowolną ilością szat graficznych, w tym własnych.'
            + ' Zakup w sklepie po stronie klienta jest niezwykle prosty, szybki i intuicyjny a procedura składania'
            + ' zamówienia skrócona do minimum.',
        image: webMarketLogo
    },
    {
        title: 'AptusShop',
        url: 'https://www.aptusshop.pl/',
        description: 'AptusShop to platforma stworzona przez firmę Aptus.pl, którą dopasowujemy indywidualnie do'
            + ' każdego klienta. Wielość modułów dodatkowych, jakie może wybrać zlecający oraz elastyczny charakter'
            + ' platformy umożliwiają rozwój działalności w dowolnym momencie. Ta nowoczesna aplikacja służąca do'
            + ' prowadzenia sprzedaży internetowej posiada wygodny panel administracyjny oraz jest możliwa do'
            + ' integracji z systemami zewnętrznymi – systemami płatności, porównywarkami cen, systemami firm'
            + ' kurierskich, itd. Zapraszamy do zapoznania się z pełną ofertą naszej firmy oraz do kontaktu'
            + ' z naszymi przedstawicielami.',
        image: aptusLogo
    },
    {
        title: 'Sky-Shop.pl',
        url: 'https://sky-shop.pl',
        description: 'Sky-Shop.pl to w pełni funkcjonalne, gotowe narzędzie do prowadzenia sklepu internetowego,'
            + ' dropshippingu i handlu na Allegro. System dostarczany jest w formie abonamentowej. Łączy'
            + ' w&nbsp;sobie ponad 1 200 funkcji ułatwiających i automatyzujących sprzedaż. Wyróżnia się łatwością'
            + ' i intuicyjnością obsługi, dzięki czemu z zaawansowanych rozwiązań e-commerce mogą korzystać'
            + ' wszyscy sprzedawcy – bez konieczności posiadania wiedzy technicznej.\n\n'
            + 'Klienci platformy szczególnie cenią dostępne z poziomu panelu administracyjnego rozbudowane funkcje'
            + ' wspomagające pozycjonowanie sklepów internetowych, aplikację mobilną do zarządzania sklepem, bardzo'
            + ' zaawansowane integracje z hurtowniami i Allegro oraz pomocny support.',
        image: skyShopLogo
    },
    {
        title: 'Wygodne Zwroty',
        url: 'https://wygodnezwroty.pl/dla-sklepow?utm_source=Opineo&utm_medium=logotyp&utm_campaign=B2B-logo-Partner-Opineo',
        image: wzLogo
    },
    {
        title: 'TrisoSHOP',
        url: 'https://www.trisoshop.pl/integracje/integracja-z-porownywarka-opinii-opineo-pl',
        image: trisoshopLogo
    },
    {
        title: 'Sote',
        url: 'https://www.sote.pl/opineo-wiarygodne-opinie.html',
        image: soteLogo
    },
    {
        title: 'WooCommerce',
        url: 'https://www.wpdesk.pl/sklep/opineo-woocommerce/',
        image: woocommerceLogo
    },
    {
        title: 'Home.pl',
        url: 'https://pomoc.home.pl/baza-wiedzy/jak-zintegrowac-sklep-z-serwisem-opineo',
        image: homeLogo
    }
];
